module.exports = __webpack_public_path__ + "static/media/kemurdzhian.31862aea.png";